import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ppl-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AccountComponent {
}
